/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 気道確保器具
 */
export type TreatmentAirwayManagementDeviceTypeEnum =
  (typeof TreatmentAirwayManagementDeviceTypeEnum)[keyof typeof TreatmentAirwayManagementDeviceTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentAirwayManagementDeviceTypeEnum = {
  AIRWAY_MANAGEMENT: 'AIRWAY_MANAGEMENT',
  LT: 'LT',
  LM: 'LM',
  CB: 'CB',
  OTHER: 'OTHER',
} as const;
